import { render, staticRenderFns } from "./UserViewDialog.vue?vue&type=template&id=b5c0a158&scoped=true&"
import script from "./UserViewDialog.vue?vue&type=script&lang=js&"
export * from "./UserViewDialog.vue?vue&type=script&lang=js&"
import style0 from "./UserViewDialog.vue?vue&type=style&index=0&id=b5c0a158&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c0a158",
  null
  
)

export default component.exports